import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { getFixedDosage } from "../../utils/helper";

const ServingsSection = ({
  isRawType,
  overallTotal,
  totalPacket,
  packetsPerDay,
  setPacketsPerDay,
  days,
  setDays,
  scoops,
  setScoops,
  timePerDay,
  setTimePerDay,
  rawGramPerDayBeforeConversion,
  prepMethod,
  requireServing,
  isConverted,
}) => {
  const [firstTime, setFirstTime] = useState(true);
  const prevPrepMethodId = useRef(prepMethod?.id);
  useEffect(() => {
    if (isConverted) {
      const scoops = Math.floor(
        parseFloat(overallTotal.totalDosage) / (parseInt(3) * parseInt(days)),
      );
      setScoops(
        isNaN(Number(scoops)) || !isFinite(scoops) ? 0 : Number(scoops),
      );
    }
  }, []);

  useEffect(() => {
    if (!firstTime && scoops > 0) {
      const prevId = prevPrepMethodId.current;
      const newId = prepMethod?.id;

      if (prevId !== newId) {
        if (newId === 5 && prevId !== 5) {
          setScoops(Math.round(scoops * 3));
        } else if (prevId === 5 && newId !== 5) {
          setScoops(Math.round(scoops / 3));
        }
      }
      prevPrepMethodId.current = newId;
    } else {
      setFirstTime(false);
    }
  }, [prepMethod]);

  return (
    <div className="serving-section border">
      <h5 className="heading">
        Serving Instructions{" "}
        {!isRawType &&
        rawGramPerDayBeforeConversion &&
        rawGramPerDayBeforeConversion != null ? (
          <span
            className="page-desc ml-5"
            style={{ marginBottom: 0, color: "white" }}
          >
            Note: Daily Recommended Dosage:{" "}
            {getFixedDosage(rawGramPerDayBeforeConversion)}g (equivalent to 1
            packet of Raw herbs)
          </span>
        ) : (
          ""
        )}
      </h5>

      {isRawType ? (
        <>
          <table className="table">
            <tbody>
              <tr>
                <th>SERVINGS{requireServing ? "*" : ""}</th>
                <th className="text-center">Packet(s)/Day</th>
                <th></th>
                <th className="text-center">Day(s)</th>
                <th></th>
                <th className="text-center">
                  Instruction
                  <br /> Total Packet(s)
                </th>
                <th className="text-center">
                  Prescription
                  <br /> Total Packet(s)
                </th>
              </tr>
              <tr>
                <td></td>
                <td className="number-field-wrapper">
                  <div className="number-field">
                    <input
                      value={packetsPerDay}
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setPacketsPerDay(parseInt(e.target.value))
                          : setPacketsPerDay(0);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setPacketsPerDay(packetsPerDay + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setPacketsPerDay(
                            packetsPerDay > 0 ? packetsPerDay - 1 : 0,
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="text-center">x</td>
                <td className="number-field-wrapper">
                  <div className="number-field ">
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      value={days}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setDays(parseInt(e.target.value))
                          : setDays(0);
                      }}
                    />
                    <div>
                      <div className="icon" onClick={() => setDays(days + 1)}>
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() => setDays(days > 0 ? days - 1 : 0)}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="text-center">=</td>
                <td className="text-center">{packetsPerDay * days}</td>
                <td className="text-center">{totalPacket}</td>
              </tr>
            </tbody>
          </table>
        </>
      ) : (
        <div className="wrapper">
          <table className="table">
            <tbody>
              <tr>
                {/* <th>SERVINGS{requireServing ? "*" : ""}</th>
                <th></th> */}
                <th className="">
                  <label className="ml-1">Serving Size</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Frequency</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Duration</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Daily Dosage</label>
                </th>
                <th className="">
                  {" "}
                  <label className="ml-1">Total Grams</label>
                </th>
              </tr>
              <tr>
                {/* <td className="number-field-wrapper" style={{ width: "130px" }}>
                  (1 scoop = 1 g)
                  <br />
                  (1 capsule = 0.5 g)
                </td>
                <td className="text-center">x</td> */}
                <td
                  className="number-field-wrapper"
                  style={{ position: "relative" }}
                >
                  <div
                    className={`number-field ${
                      scoops <= 0 && (days > 0 || timePerDay > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      value={scoops}
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setScoops(parseInt(e.target.value))
                          : setScoops(0);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setScoops(parseInt(scoops) + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setScoops(
                            parseInt(scoops) > 0 ? parseInt(scoops) - 1 : 0,
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                    <p
                      className="ml-1 mt-1"
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        position: "absolute",
                        top: "75%",
                      }}
                    >
                      {prepMethod?.id == 1
                        ? `(1 scoop = 1.5 grams)`
                        : prepMethod?.id == 7
                          ? `(1 scoop = 1.5 grams)`
                          : prepMethod?.id == 5
                            ? "(1 capsule = 0.5 grams)"
                            : prepMethod?.id == 6
                              ? "Tablets"
                              : ""}
                    </p>
                  </div>
                  <p className="ml-1 mt-1">
                    {prepMethod?.id == 1
                      ? "Scoops"
                      : prepMethod?.id == 7
                        ? "Scoops"
                        : prepMethod?.id == 5
                          ? "Capsules"
                          : prepMethod?.id == 6
                            ? "Tablets"
                            : ""}
                  </p>
                </td>
                <td className="text-center"></td>
                <td className="number-field-wrapper">
                  <div
                    className={`number-field ${
                      timePerDay <= 0 && (days > 0 || scoops > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      value={timePerDay}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setTimePerDay(parseInt(e.target.value))
                          : setTimePerDay(0);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setTimePerDay(parseInt(timePerDay) + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setTimePerDay(
                            parseInt(timePerDay) > 0
                              ? parseInt(timePerDay) - 1
                              : 0,
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                  <p className="ml-1 mt-1">Time(s) per day</p>
                </td>
                <td className="text-center"></td>
                <td className="number-field-wrapper">
                  <div
                    className={`number-field ${
                      days <= 0 && (timePerDay > 0 || scoops > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      value={days}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setDays(parseInt(e.target.value))
                          : setDays(0);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setDays(parseInt(days) + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setDays(parseInt(days) > 0 ? parseInt(days) - 1 : 0)
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                  <p className="ml-1 mt-1">Day(s)</p>
                </td>
                <td className="text-center"></td>
                <td className="">
                  <b>
                    {scoops * timePerDay * (prepMethod?.id == 5 ? 0.5 : 1.5)}{" "}
                    grams
                  </b>
                </td>
                <td className="">
                  <b>
                    {scoops *
                      timePerDay *
                      (prepMethod?.id == 5 ? 0.5 : 1.5) *
                      days}{" "}
                    grams
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
          {/* <p className="page-desc">
            Note: All fields must be filled in order for the serving
            instructions to be printed on the label.
          </p> */}
        </div>
      )}
    </div>
  );
};

export default ServingsSection;
